export default __webpack_public_path__ + "static/media/sad-orange.53daac0b.svg";